import React from 'react';
import Badge, { BadgeBg } from 'components/base/Badge';
import FeatherIcon from 'feather-icons-react';
import { 
  ResolutionType, 
  getResolutionTypeLabels,
  resolutionTypeIcons, 
  resolutionTypeBadges 
} from 'hooks/refunds/useRmaDetails';
import { useTranslation } from 'react-i18next';

interface RmaResolutionBadgeProps {
  resolutionType: number;
  className?: string;
}

const RmaResolutionBadge: React.FC<RmaResolutionBadgeProps> = ({ 
  resolutionType, 
  className = ''
}) => {
  const { t } = useTranslation();
  // Get the translated labels
  const resolutionTypeLabels = getResolutionTypeLabels();
  let label: string;
  let badgeType: BadgeBg;
  let icon: string;
  
  // Get the correct badge configuration based on resolution type
  switch (resolutionType) {
    case ResolutionType.REFUND:
      label = resolutionTypeLabels[ResolutionType.REFUND];
      badgeType = resolutionTypeBadges[ResolutionType.REFUND] as BadgeBg;
      icon = resolutionTypeIcons[ResolutionType.REFUND];
      break;
    case ResolutionType.REPLACE:
      label = resolutionTypeLabels[ResolutionType.REPLACE];
      badgeType = resolutionTypeBadges[ResolutionType.REPLACE] as BadgeBg;
      icon = resolutionTypeIcons[ResolutionType.REPLACE];
      break;
    case ResolutionType.CANCEL:
      label = resolutionTypeLabels[ResolutionType.CANCEL];
      badgeType = resolutionTypeBadges[ResolutionType.CANCEL] as BadgeBg;
      icon = resolutionTypeIcons[ResolutionType.CANCEL];
      break;
    default:
      label = t('common.notAvailable');
      badgeType = 'secondary';
      icon = 'help-circle';
  }
  
  return (
    <Badge
      bg={badgeType}
      variant="phoenix"
      iconPosition="end"
      className={`fs-10 ${className}`}
      icon={
        <FeatherIcon
          icon={icon}
          size={12.8}
          className="ms-1"
        />
      }
    >
      {label}
    </Badge>
  );
};

export default RmaResolutionBadge;
